import { render, staticRenderFns } from "./MediaRecord.vue?vue&type=template&id=6df96962&scoped=true"
import script from "./MediaRecord.vue?vue&type=script&lang=js"
export * from "./MediaRecord.vue?vue&type=script&lang=js"
import style0 from "./MediaRecord.vue?vue&type=style&index=0&id=6df96962&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df96962",
  null
  
)

export default component.exports